export interface AppVersion {
    id: string;
    platform: AppPlatform;
    version: string;
    major: number;
    minor: number;
    patch: number;
    state: AppState;
    changeLog: AppChangeLogEntry[];
    publishedAt: string;
    lastChangedAt: string;
    createdAt: string;
}

export interface AppChangeLogEntry {
    header: string;
    text: string;
}

export enum AppPlatform {
    Android,
    iOS
}

export enum AppState {
    Productive,
    OpenBeta,
    Planned
}

export interface AppVersionMinimal {
    major: number;
    minor: number;
    patch: number;
}

export const versionStringToAppVersion = (versionString: string): AppVersionMinimal | undefined => {
    const split = versionString.split('.');
    if (split.length !== 3) { return undefined; }
    if (isNaN(+split[0]) || isNaN(+split[1]) || isNaN(+split[2])) { return undefined; }
    return { major: +split[0], minor: +split[1], patch: +split[2] };
};

export const isVersionLaterOrEqual = (v1: AppVersion | AppVersionMinimal, v2: AppVersion | AppVersionMinimal,
                                      includePatch: boolean): boolean => {
    if (v1.major > v2.major) { return true; }
    if (v1.major < v2.major) { return false; }
    if (v1.minor > v2.minor) { return true; }
    if (v1.minor < v2.minor) { return false; }
    if (!includePatch) { return true; }
    if (v1.patch < v2.patch) { return false; }
    return true;
};

export const isVersionLater = (v1: AppVersion | AppVersionMinimal, v2: AppVersion | AppVersionMinimal,
                               includePatch: boolean): boolean => {
    if (v1.major > v2.major) { return true; }
    if (v1.major < v2.major) { return false; }
    if (v1.minor > v2.minor) { return true; }
    if (v1.minor < v2.minor) { return false; }
    if (!includePatch) { return false; }
    if (v1.patch > v2.patch) { return true; }
    return false;
};
